﻿import { IUserContext } from "./UserContext";

export const defaultState: IUserContext = {
    dateFormat: "MM/dd/yyyy",
    id: "00000000-0000-0000-0000-000000000000",
    name: "Unknown User",
    timeFormat: "hh:mm a",
};
